// extracted by mini-css-extract-plugin
export default {"container":"CreateNewCampaign_container__ReCgZ","loading":"CreateNewCampaign_loading__ghJmV","prepare":"CreateNewCampaign_prepare__G6ekn"};